import { forwardRef, useImperativeHandle, useRef, useEffect } from "react";
import useForm from "../../hooks/useForm";
import {
  initialElement,
  propsElementoFabrica,
} from "../../utils/formsInitialsStates";

interface Props {
  handleSubmit?: (values: propsElementoFabrica) => void;
  data?: propsElementoFabrica;
  on?: string;
}

export const MaterialForm = forwardRef(
  ({ handleSubmit, data, on }: Props, ref) => {
    const {
      handleInputChange,
      formValues,
      resetForm,
      changeMulti,
      validateForm,
    } = useForm<propsElementoFabrica>(initialElement);
    const form = useRef<HTMLFormElement>(null);

    const submitForm = (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      handleSubmit && handleSubmit(formValues);
    };
    useImperativeHandle(ref, () => ({
      handleClick: () => {
        form.current?.requestSubmit();
        if (form.current && validateForm(form.current.elements)) {
          return formValues;
        }
      },
      resetForm: () => resetForm(),
    }));
    useEffect(() => {
      if (data) changeMulti(data);
    }, [data, changeMulti]);

    return (
      <form
        className="p-3"
        id="formBancos"
        ref={form}
        autoComplete="off"
        onSubmit={submitForm}
        noValidate
      >
        <div className="row">
          <div className="col-md-6">
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="nombre"
                name="nombre"
                value={formValues.nombre}
                onChange={handleInputChange}
                placeholder="-"
                data-uppercase="change"
                data-trim="submit"
                required
              />
              <label htmlFor="nombre">Nombre del producto</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating mb-3">
              <select
                className="form-select"
                id="unidad_medida"
                name="unidad_medida"
                value={formValues.unidad_medida}
                onChange={handleInputChange}
                required
              >
                <option value="" disabled>
                  Seleccione medidas
                </option>
                <option value="lts">Litros</option>
                <option value="mlt">Mililitros</option>
                <option value="gr">Gramos</option>
                <option value="kg">Kilos</option>
              </select>
              <label htmlFor="unidad_medida">Medida por:</label>
            </div>
          </div>
        </div>
        <div className="row">
        <div className="col-md-8">
          <div className="form-floating mb-3">
            <select className="form-select" id="estado" name="estado" value={Number(formValues.estado)} onChange={handleInputChange} required>
              <option value="" disabled>Seleccione un estado</option>
              <option value={1}>Habilitado</option>
              <option value={0}>Inhabilitado</option>
            </select>
            <label htmlFor="estado">Habilitar/Inhabilitar</label>
          </div>
        </div>
        </div>
      </form>
    );
  }
);
